import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const onlineClassSetData = (onlineClass) => {
  return {
    type: actionType.ONLINE_CLASS_SET_DATA,
    onlineClass: onlineClass,
  };
};

export const onlineClassFailData = (error) => {
  return {
    type: actionType.ONLINE_CLASS_FAIL_DATA,
    error: error,
  };
};

export const onlineClassLoading = () => {
  return {
    type: actionType.ONLINE_CLASS_LOADING,
  };
};

export const onlineClassGetData = () => {
  return (dispatch) => {
    dispatch(onlineClassLoading());
    axios
      .get(baseUrl + "/class-subscriptions", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(onlineClassSetData(res.data));
      })
      .catch((error) => dispatch(onlineClassFailData(error)));
  };
};

export const deleteOnlineClassFail = (error) => {
  return {
    type: actionType.DELETE_ONLINE_CLASS_FAIL,
    error: error,
  };
};

export const deleteOnlineClass = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/class-subscriptions/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(onlineClassGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteOnlineClassFail()));
    }
  };
};

export const postOnlineClassDataStart = () => {
  return {
    type: actionType.POST_ONLINE_CLASS_DATA_START,
  };
};

export const postOnlineClassDataFail = (error) => {
  return {
    type: actionType.POST_ONLINE_CLASS_DATA_FAIL,
    error: error,
  };
};

export const postOnlineClassDataSuccess = (success) => {
  return {
    type: actionType.POST_ONLINE_CLASS_DATA_SUCCESS,
    success: success,
  };
};

export const onlineClassPostLoading = () => {
  return {
    type: actionType.ONLINE_CLASS_POST_LOADING,
  };
};

export const postOnlineClassData = (data, onlineClass, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(postOnlineClassDataStart());
    dispatch(onlineClassPostLoading());
    axios
      .post(baseUrl + "/class-subscriptions", onlineClass, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postOnlineClassDataSuccess(res.data));
        dispatch(onlineClassGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postOnlineClassDataFail(error));
      });
  };
};

export const updateOnlineClassDataStart = () => {
  return {
    type: actionType.UPDATE_ONLINE_CLASS_DATA_START,
  };
};

export const onlineClassUpdateLoading = () => {
  return {
    type: actionType.ONLINE_CLASS_UPDATE_LOADING,
  };
};

export const updateOnlineClassDataFail = (error) => {
  return {
    type: actionType.UPDATE_ONLINE_CLASS_DATA_FAIL,
    error: error,
  };
};

export const updateOnlineClassDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_ONLINE_CLASS_DATA_SUCCESS,
    success: success,
  };
};

export const updateOnlineClassData = (data, onlineClass, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateOnlineClassDataStart());
    dispatch(onlineClassUpdateLoading());

    axios
      .put(baseUrl + `/class-subscriptions/${data.id}`, onlineClass, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateOnlineClassDataSuccess(res.data));
        dispatch(onlineClassGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateOnlineClassDataFail(error));
      });
  };
};
